module.exports = __webpack_public_path__ + "img/gold.f8516612.png";